module.exports = __webpack_public_path__ + "templates.dialog.customer-return-order-3ac91e85.html";